import script from "./HolidayHoursDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidayHoursDialog.vue?vue&type=script&setup=true&lang=js"

import "./HolidayHoursDialog.vue?vue&type=style&index=0&id=51f1afe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f1afe2"]])

export default __exports__